import {Quiz} from "types/Quiz";
import {dateTime} from "services/date";
import deserializeQuizQuestion from "services/ngage/deserializers/quiz-question";

/**
 * Transform the given quiz by deserializing object properties
 *
 * @internal
 * @param quiz
 */
export default function deserializeQuiz(quiz: any): Quiz {
    quiz.created_at = dateTime(quiz.created_at)
    quiz.updated_at = dateTime(quiz.updated_at)

    if(quiz.questions){
        quiz.questions = quiz.questions.map(deserializeQuizQuestion)
    }

    return quiz;
}